import { hooks } from '../../../config/api';
export var useFindSocialInsurances = function useFindSocialInsurances(contactId) {
  var _response$data$data, _response$data;
  var states = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'active,pending,inactive';
  var _hooks$useFind = hooks.useFind('insurance', {
      person: contactId,
      state: states,
      'plan.plan_type': 'social'
    }, {
      queryConfig: {
        placeholderData: undefined
      }
    }),
    response = _hooks$useFind.data,
    isLoading = _hooks$useFind.isLoading;
  var socialInsurances = (_response$data$data = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) !== null && _response$data$data !== void 0 ? _response$data$data : [];
  var _hooks$usePopulate = hooks.usePopulate('plan', 'plan', socialInsurances, {
      queryConfig: {
        placeholderData: undefined
      }
    }),
    isPopulating = _hooks$usePopulate.isLoading;
  return {
    socialInsurances: socialInsurances,
    isLoading: isLoading || isPopulating
  };
};
//# sourceMappingURL=useFindSocialInsurances.js.map